import React, { useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { EventStudentDTO } from "../../../../models/EventDTO";
import S from "./strings";

interface Props {
	campusId: number;
	eventId: number;
	/** Graduada / participante: quien ya va a otro evento no se puede elegir (el servidor también lo rechaza). */
	bloquearSiVa: boolean;
	onPick: (s: { id: number; name: string; code: string }) => void;
}

/** Fase 3 (Online a Eventos): busca alumnas del plantel y de Online que caben en este evento; marca «Online» y «Ya va a …». */
const BuscarAlumnaEvento: React.FC<Props> = ({ campusId, eventId, bloquearSiVa, onPick }) => {
	const http = HttpManager.getInstance();
	const [q, setQ] = useState<string>("");
	const [found, setFound] = useState<EventStudentDTO[] | null>(null);
	const [busy, setBusy] = useState<boolean>(false);
	const buscar = () => {
		if (q.trim().length < 2 || busy) return;
		setBusy(true);
		http.eventsService.students(campusId, eventId, q.trim())
			.then(r => setFound(r.data || []))
			.catch(() => setFound([]))
			.finally(() => setBusy(false));
	};
	return (
		<div>
			<div className="wau-fila">
				<input type="search" className="wau-entrada" style={{ maxWidth: 320 }} placeholder={S.buscarAlumna} value={q}
					onChange={e => setQ(e.target.value)} onKeyDown={e => { if (e.key === "Enter") buscar(); }} />
				<button type="button" className="wau-btn s" disabled={busy || q.trim().length < 2} onClick={buscar}>{S.buscarBtn}</button>
			</div>
			{found === null ? null : (
				<div className="wau-lista" style={{ marginTop: 8, maxWidth: 520 }}>
					{found.length === 0 ? <span className="wau-sec">{S.sinResultados}</span> : found.map(s => {
						const bloqueada = bloquearSiVa && !!s.goingTo;
						return (
							<button key={s.id} type="button" className="wau-item" disabled={bloqueada} style={bloqueada ? { cursor: "not-allowed", opacity: 0.75 } : undefined}
								onClick={() => { if (bloqueada) return; onPick({ id: s.id, name: s.name, code: s.code }); setFound(null); setQ(""); }}>
								<span>{s.name}{s.online ? <> <span className="wau-pastilla">{S.online}</span></> : null}{s.goingTo ? <> <span className="wau-pastilla oro" style={{ whiteSpace: "normal" }}>{S.yaVaA(s.goingTo)}</span></> : null}</span>
								<span className="sub">{s.code}</span>
							</button>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default BuscarAlumnaEvento;
